(function () {
  'use strict';
  if (window.__themeMediaRuntime) return;
  window.__themeMediaRuntime = true;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  var saveData = connection && connection.saveData;
  var loadObserver;
  var playObserver;

  function hydrate(video) {
    if (video.dataset.mediaHydrated === 'true') return;
    var sources = video.querySelectorAll('source[data-src]');
    sources.forEach(function (source) {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.dataset.mediaHydrated = 'true';
    if (sources.length) video.load();
  }

  function toggle(video) {
    hydrate(video);
    if (video.paused) {
      var promise = video.play();
      if (promise && promise.catch) promise.catch(function () {});
    } else {
      video.pause();
    }
  }

  function wire(video) {
    if (video.dataset.mediaWired === 'true') return;
    video.dataset.mediaWired = 'true';
    var wrapper = video.closest('.ai-media');

    video.addEventListener('pointerdown', function () { hydrate(video); }, { once: true });
    video.addEventListener('keydown', function () { hydrate(video); }, { once: true });
    video.addEventListener('pause', function () {
      if (video.dataset.mediaInView === 'true') video.dataset.mediaUserPaused = 'true';
    });
    video.addEventListener('play', function () { video.dataset.mediaUserPaused = 'false'; });

    if (wrapper && wrapper.classList.contains('ai-media--bare')) {
      video.addEventListener('click', function () { toggle(video); });
      video.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        toggle(video);
      });
    }

    if (reducedMotion.matches) {
      video.autoplay = false;
      video.removeAttribute('autoplay');
      return;
    }
    if (loadObserver && !saveData) loadObserver.observe(video);
    if (playObserver && video.closest('.ai-media--auto')) playObserver.observe(video);
  }

  function wireAll(root) {
    (root || document).querySelectorAll('.ai-media--video video').forEach(wire);
  }

  if ('IntersectionObserver' in window) {
    loadObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        hydrate(entry.target);
        loadObserver.unobserve(entry.target);
      });
    }, { rootMargin: '600px 0px', threshold: 0 });

    playObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        video.dataset.mediaInView = entry.isIntersecting ? 'true' : 'false';
        if (entry.isIntersecting) {
          if (saveData || video.dataset.mediaUserPaused === 'true') return;
          hydrate(video);
          var promise = video.play();
          if (promise && promise.catch) promise.catch(function () {});
        } else if (!video.paused) {
          video.pause();
        }
      });
    }, { threshold: 0.2 });
  }

  function start() {
    wireAll(document);
    if (!('IntersectionObserver' in window) && !saveData) {
      document.querySelectorAll('.ai-media--video video').forEach(hydrate);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  document.addEventListener('shopify:section:load', function (event) { wireAll(event.target); });
  if (reducedMotion.addEventListener) {
    reducedMotion.addEventListener('change', function () {
      if (!reducedMotion.matches) return;
      document.querySelectorAll('.ai-media--auto video').forEach(function (video) {
        video.autoplay = false;
        video.removeAttribute('autoplay');
        video.pause();
      });
    });
  }
})();
